import { NgModule } from "@angular/core";
import { ReverseOrderComponent } from "./component/reverse-order.component";
import { FuseSharedModule } from "@fuse/shared.module";
import { MatStepperModule } from "@angular/material/stepper";
import { FooterNavigationModule } from "app/main/shared/modules/footer-navigation/footer-navigation.module";
import { SelectCourierComponent } from "./child-component/select-courier/select-courier.component";
import { Routes, RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { PipesModule } from "app/main/shared/pipes/pipes.module";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatRadioModule } from "@angular/material/radio";
import { ConfirmReverseComponent } from "./child-component/confirm-reverse/confirm-reverse.component";
import { DataLoaderModule } from "app/main/shared/modules/dynamic-table/table-components/data-loader/data-loader.module";
import { ToolbarHeadingModule } from "app/main/shared/components/toolbar-heading/toolbar-heading.module";
import { CourierPartnerChargesModule } from "app/main/shared/modules/courier-partner-charges/courier-partner-charges.module";
import { ViewPreferenceModule } from "app/main/shared/modules/view-preference/view-preference.module";
import { SelectCourierPartnerModule } from "app/main/shared/modules/select-courier-partner/select-courier-partner.module";
import { EditItemsComponent } from "./child-component/edit-items/edit-items.component";
import { ErrorMessageModule } from "app/main/shared/modules/error-message/error-message.module";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { ReverseBoxDetailsComponent } from "./child-component/reverse-box-details/reverse-box-details.component";
import { MatSelectModule } from "@angular/material/select";
import { StringFilterByModule } from "app/main/shared/pipes/string-filter-by/string-filter-by.module";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatToolbarModule } from "@angular/material/toolbar";
import { ImageLinksDialogComponent } from "./child-component/image-links-dialog/image-links-dialog.component";

const routes: Routes = [
  {
    path: "",
    component: ReverseOrderComponent
  }
];

@NgModule({
  declarations: [
    ReverseOrderComponent,
    SelectCourierComponent,
    ConfirmReverseComponent,
    EditItemsComponent,
    ReverseBoxDetailsComponent,
    ImageLinksDialogComponent
  ],
  imports: [
    RouterModule.forChild(routes),

    // shared
    FuseSharedModule,
    PipesModule,
    FooterNavigationModule,
    DataLoaderModule,
    ToolbarHeadingModule,
    CourierPartnerChargesModule,
    ViewPreferenceModule,
    SelectCourierPartnerModule,
    ErrorMessageModule,

    //material
    MatStepperModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatTooltipModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDialogModule,
    MatToolbarModule,
    StringFilterByModule,
    NgxMatSelectSearchModule
  ],
  exports: [
    ImageLinksDialogComponent
  ]
})
export class ReverseOrderModule {}
